import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    DELETE_TASK: (taskId, callback) => ({ taskId, callback }),
    API: {
      DELETE_TASK: apiResourceActionCreator('task')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/${payload.taskId}`, authToken, actions.task.api.deleteTask);

function* deleteTask(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.task.api.deleteTask);

  if (result.success) {
    action.payload.callback()
  }
}

const configuration = {
  name: 'deleteTask',
  action: actions,
  sagas: deleteTask,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/deleteTask.js